// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"29fd30c4","776":"d2062337"}[chunkId] + ".chunk.js";
};